import { SUPPORTED_LANGUAGES, isSupportedLanguage } from './supported-languages'

function isSafeInternalPath(path: string | null | undefined): path is string {
  return typeof path === 'string' && /^\/(?!\/)/.test(path)
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const supportedLanguagePrefixRegExp = new RegExp(
  `^/(${SUPPORTED_LANGUAGES.map(escapeRegExp).join('|')})([/?#]|$)`,
)

const ENGLISH_RESOURCES_PREFIX = /^\/resources(?=\/|[?#]|$)/
const RUSSIAN_RESOURCES_PREFIX = /^\/ru\/resources(?=\/|[?#]|$)/

function stripEnglishPrefix(path: string): string {
  const clean = path.replace(/^\/en(?=\/|[?#]|$)/, '')
  return clean === '' || clean.startsWith('?') || clean.startsWith('#')
    ? `/${clean}`
    : clean
}

export function localizeInternalPath(
  path: string | null | undefined,
  lang: string,
): string | undefined {
  if (!isSafeInternalPath(path)) {
    return undefined
  }

  const firstSegment = path.split(/[/?#]/, 2)[1]
  if (isSupportedLanguage(firstSegment)) {
    return firstSegment === 'en' && lang === 'en'
      ? stripEnglishPrefix(path)
      : path
  }

  return lang === 'en' ? path : path === '/' ? `/${lang}` : `/${lang}${path}`
}

export function replaceSupportedLanguageInHref(
  href: string,
  lang: string,
): string {
  if (!isSafeInternalPath(href)) {
    return lang === 'en' ? '/' : `/${lang}`
  }

  if (lang === 'ru' && ENGLISH_RESOURCES_PREFIX.test(href)) {
    return `/ru${href}`
  }

  if (lang === 'en' && RUSSIAN_RESOURCES_PREFIX.test(href)) {
    return href.replace(/^\/ru/, '')
  }

  if (supportedLanguagePrefixRegExp.test(href)) {
    const localized = href.replace(supportedLanguagePrefixRegExp, `/${lang}$2`)
    return lang === 'en' ? stripEnglishPrefix(localized) : localized
  }

  return localizeInternalPath(href, lang) ?? (lang === 'en' ? '/' : `/${lang}`)
}
